import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

export const apiFetchDailyRouteLeadingCountStatusList = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getDailyRouteLeadingCountStatusReport',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, payload.params);
};
